import React, { useRef, useState } from "react";
import "./style.css";
import {
  IoChevronBack,
  IoChevronDown,
  IoChevronForward,
  IoChevronUp,
  IoPlay,
} from "react-icons/io5";
import { FaCheck, FaPlus } from "react-icons/fa";
import hero from "../Images/Home Section/pushpa-2-1-1.png";
import hero1 from "../Images/Home Section/salaar-34.png";
import hero2 from "../Images/Home Section/kgf2.png";
import hero3 from "../Images/Home Section/kantara.png";
import hero4 from "../Images/Home Section/pathan.png";
import hero5 from "../Images/Home Section/shamsher.jpeg";
import hero6 from "../Images/Home Section/bramhyog.png";
import hero7 from "../Images/Home Section/joker.png";
import hero8 from "../Images/Home Section/maidan.png";
import got1 from "../Images/Home Section/GOT/got1.png";
import got2 from "../Images/Home Section/GOT/got 2.jpg";
import got3 from "../Images/Home Section/GOT/got 3.jpg";
import got4 from "../Images/Home Section/GOT/got 4.jpg";
import got5 from "../Images/Home Section/GOT/got 5.jpg";
import got6 from "../Images/Home Section/GOT/got 6.jpg";
import got7 from "../Images/Home Section/GOT/got 7.jpg";
import peacky from "../Images/Home Section/GOT/peacky_blinders.jpg";
import breakingbad from "../Images/Home Section/GOT/breakingbad.jpg";
import deadpool from "../Images/Home Section/GOT/deadpool.jpg";
import devra from "../Images/Home Section/GOT/devra.jpg";
import stranger from "../Images/Home Section/GOT/the_stranger.jpg";
import punisher from "../Images/Home Section/GOT/the_punisher.jpg";
import harry from "../Images/Home Section/GOT/harry potter.jpg";
import kanuaa from "../Images/Home Section/GOT/kanuaa.jpg";
import crew from "../Images/Home Section/GOT/crew.jpg";
import drishyam from "../Images/Home Section/GOT/drishyam.jpg";
import raid from "../Images/Home Section/GOT/raid.jpg";
import stree from "../Images/Home Section/GOT/stree 2.jpg";
import puspa2 from "../Images/videoSong/Pushpa.mp4";
import salaar from "../Images/videoSong/Salaar.mp4";
import kgf from "../Images/videoSong/KGF.mp4";
import kantara from "../Images/videoSong/Kantara.mp4";
import pathaan from "../Images/videoSong/Pathaan.mp4";
import samshera from "../Images/videoSong/Shamshera.mp4";
import bramhyog from "../Images/videoSong/Bramayugam.mp4";
import joker2 from "../Images/videoSong/Joker.mp4";
import maidaan from "../Images/videoSong/Joker.mp4";
import { Col, Container, Form, Row } from "react-bootstrap";
const MainContentPage = () => {
  const [open, setOpen] = useState(false);
  const [view, setView] = useState(false);
  const [added, setAdded] = useState(false);
  const scrollContainerRef = useRef(null);

  const media = [
    {
      id: 1,
      type: "image",
      src: hero,
      title: "Pushpa 2: The Rule",
      video: puspa2,
      Year: 2023,
      imdb: "8.3 rating",
    },
    {
      id: 2,
      type: "image",
      src: hero1,
      title: "Salaar",
      video: salaar,
      Year: 2023,
      imdb: "8.3 rating",
    },
    {
      id: 3,
      type: "image",
      src: hero2,
      title: "KGF: Chapter 2",
      video: kgf,
      Year: 2023,
      imdb: "8.3 rating",
    },
    {
      id: 4,
      type: "image",
      src: hero3,
      title: "Kantara",
      video: kantara,
      Year: 2023,
      imdb: "8.3 rating",
    },
    {
      id: 5,
      type: "image",
      src: hero4,
      title: "Pathan",
      video: pathaan,
      Year: 2023,
      imdb: "8.3 rating",
    },
    {
      id: 6,
      type: "image",
      src: hero5,
      title: "Shamshera",
      video: samshera,
      Year: 2023,
      imdb: "8.3 rating",
    },
    {
      id: 7,
      type: "image",
      src: hero6,
      title: "BrahmYog",
      video: bramhyog,
      Year: 2023,
      imdb: "8.3 rating",
    },
    {
      id: 8,
      type: "image",
      src: hero7,
      title: "Joker",
      video: joker2,
      Year: 2023,
      imdb: "8.3 rating",
    },
    {
      id: 9,
      type: "image",
      src: hero8,
      title: "Maidaan",
      video: maidaan,
      Year: 2023,
      imdb: "8.3 rating",
    },
  ];

  const videoData = [
    {
      id: 1,
      image: got1,
      title: "Game of Thrones",
      episode: "S-07 E-06",
      currentTime: "43:02",
      totalTime: "59:02",
      progress: 72,
    },
    {
      id: 2,
      image: got2,
      title: "Game of Thrones",
      episode: "S-07 E-07",
      currentTime: "20:15",
      totalTime: "55:00",
      progress: 36,
    },
    {
      id: 3,
      image: got3,
      title: "Game of Thrones",
      episode: "S-08 E-01",
      currentTime: "10:00",
      totalTime: "50:00",
      progress: 20,
    },
    {
      id: 4,
      image: got4,
      title: "Game of Thrones",
      episode: "S-08 E-02",
      currentTime: "30:00",
      totalTime: "60:00",
      progress: 50,
    },
    {
      id: 5,
      image: got5,
      title: "Game of Thrones",
      episode: "S-08 E-02",
      currentTime: "30:00",
      totalTime: "60:00",
      progress: 50,
    },
    {
      id: 6,
      image: got6,
      title: "Game of Thrones",
      episode: "S-08 E-02",
      currentTime: "30:00",
      totalTime: "60:00",
      progress: 50,
    },
    {
      id: 7,
      image: got7,
      title: "Game of Thrones",
      episode: "S-08 E-02",
      currentTime: "30:00",
      totalTime: "60:00",
      progress: 50,
    },
  ];

  const toprated = [
    {
      type: "image",
      rating: 4.5,
      src: peacky,
      name: "Peaky Blinders",
      Year: 2023,
    },
    {
      type: "image",
      rating: 8.8,
      src: breakingbad,
      name: "Breaking Bad",
      Year: 2022,
    },
    {
      type: "image",
      rating: 7.5,
      src: deadpool,
      name: "Deadpool",
      Year: 2020,
    },
    {
      type: "image",
      rating: 9.5,
      src: devra,
      name: "Devra",
      Year: 2024,
    },
    {
      type: "image",
      rating: 7.5,
      src: stranger,
      name: "Stranger",
      Year: 2021,
    },
    {
      type: "image",
      rating: 8.5,
      src: punisher,
      name: "Punish Her",
      Year: 2021,
    },
    {
      type: "image",
      rating: 8.8,
      src: harry,
      name: "Harry Potter",
      Year: 2011,
    },
    {
      type: "image",
      rating: 4.4,
      src: kanuaa,
      name: "Kanguaa",
      Year: 2024,
    },
    {
      type: "image",
      rating: 4.4,
      src: crew,
      name: "Crew",
      Year: 2024,
    },
    {
      type: "image",
      rating: 4.4,
      src: drishyam,
      name: "Drishyam",
      Year: 2024,
    },
    {
      type: "image",
      rating: 4.4,
      src: raid,
      name: "Raid",
      Year: 2024,
    },
    {
      type: "image",
      rating: 4.4,
      src: stree,
      name: "Stree",
      Year: 2024,
    },
  ];

  const handleWatchNow = (videoUrl) => {
    const newWindow = window.open(
      videoUrl,
      "_blank",
      "toolbar=no,scrollbars=no,resizable=yes,top=0,left=0,width=1920,height=1080"
    );

    if (newWindow) {
      newWindow.document.write(`
                <html>
                <head>
                <title>Fullscreen Video</title>
                <style>
                body{
                 margin:0,
                 overflow:hidden;
                }
                 video{
                 position: absolute;
                 top:0;
                 left:0;
                 width:100%;
                 height:100%;
                 }
                </style>
                </head>
                <body>
                <video src="${videoUrl}" controls autoplay></video>
                </body>
                </html>
                `);
      newWindow.document.close();
    }
  };

  const handleScroll = (direction) => {
    const container = scrollContainerRef.current;
    const cardWidth = container.children[0].offsetWidth;
    const scrollAmount = cardWidth * 3;

    if (direction === "left") {
      container.scrollBy({ left: -scrollAmount, behavior: "smooth" });
    } else {
      container.scrollBy({ left: scrollAmount, behavior: "smooth" });
    }
  };

  const visibleMedia = open ? media : media.slice(0, 3);
  const itemsToShow = view ? toprated : toprated.slice(0, 6);

  return (
    <div
      className="px-3"
      style={{
        height: "calc(100vh - 47px)",
        overflowY: "auto",
      }}
    >
      <div className="hstack justify-content-between align-items-center mb-3">
        <span className="fs-18 fw-bold text-white letter-spacing-sm">
          Trending Series
        </span>
        <span
          onClick={() => setOpen(!open)}
          className="fs-15 fw-bold text-white letter-spacing-sm"
          style={{ cursor: "pointer" }}
        >
          {open ? "View Less" : "View All"}{" "}
          {open ? <IoChevronUp /> : <IoChevronDown />}
        </span>
      </div>
      <div className="mb-3">
        <Container fluid>
          <Row>
            {visibleMedia.map((item, index) => (
              <Form.Label as={Col} xl={4} lg={3} md={4} sm={6} className="mb-2">
                <div className="image-container" key={index}>
                  <img src={item?.src} alt={item?.title} className="zoom w-100" />
                  <div className="card-content">
                    <div className="title-section">
                      <h2 className="fs-24 fw-bold m-0">{item?.title}</h2>
                      <p className="fs-18 m-0">{item?.Year}</p>
                    </div>
                    <div className="hstack justify-content-end gap-2">
                      <div className="rating-section w-100">
                        <div className="imdb-logo">IMDb</div>
                        <p className="fs-16 m-0">{item?.imdb}</p>
                      </div>
                      <div className="hstack gap-2 w-100 justify-content-end">
                        <button
                          className="btn btn-primary watch-now fs-13 border-0"
                          onClick={() => handleWatchNow(item.video)}
                        >
                          Watch Now
                        </button>
                        <button
                          className="bg-secondary btn fs-13 border-0"
                          title={
                            added ? "remove from watchlist" : "add to watchlist"
                          }
                          onClick={() => setAdded(!added)}
                        >
                          {added ? (
                            <FaCheck className="text-white fs-10" />
                          ) : (
                            <FaPlus className="text-white fs-10" />
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </Form.Label>
            ))}
          </Row>
          <div className="mb-3">
            <div className="hstack justify-content-between align-items-center mb-3">
              <span className="fs-18 fw-bold text-white letter-spacing-sm">
                Continue Watching
              </span>
              <span className="fs-18 fw-bold text-white letter-spacing-sm">
                View All <IoChevronForward />
              </span>
            </div>
            <div className="hstack align-items-center gap-2 position-relative">
              <IoChevronBack
                className="text-white chevron-icon fs-36 cursor-pointer h-100 bg-transparent position-absolute z-1"
                onClick={() => handleScroll("left")}
              />
              <div
                className="video-card-list hstack gap-4 hstack w-100"
                style={{ overflowX: "hidden", flexWrap: "nowrap" }}
                ref={scrollContainerRef}
              >
                {videoData.map((video) => (
                  <div
                    key={video.id}
                    className="video-card"
                    style={{
                      flex: "0 0 calc(44.5% - 155px)",
                    }}
                  >
                    <div style={{ position: "relative" }}>
                      <img
                        src={video.image}
                        alt="Video Thumbnail"
                        className="zoom w-100"
                        style={{
                          height: "210px",
                          objectFit: "cover",
                        }}
                      />
                      <div className="play-button">
                        <IoPlay className="text-white fs-24" />
                      </div>
                    </div>
                    <div className="video_details">
                      <h3>{video.title}</h3>
                      <p>{video.episode}</p>
                      <div className="progress_container">
                        <span>{video.currentTime}</span>
                        <div className="progress-bar progress_bar">
                          <div
                            className="progress-filled h-100"
                            style={{
                              width: `${video.progress}%`,
                              backgroundColor: "#38bdf8",
                            }}
                          ></div>
                        </div>
                        <span>{video.totalTime}</span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <IoChevronForward
                className="text-white chevron-icon fs-36 cursor-pointer h-100 bg-transparent position-absolute z-1 end-0"
                onClick={() => handleScroll("right")}
              />
            </div>
          </div>
        </Container>
        <div>
          <div className="hstack justify-content-between mb-3">
            <span className="fs-18 fw-bold text-white">Top Rated ⭐</span>
            <span
              onClick={() => setView(!view)}
              className="fs-18 fw-bold text-white letter-spacing-sm"
              style={{ cursor: "pointer" }}
            >
              {view ? "View Less" : "View All"}{" "}
              {view ? <IoChevronUp /> : <IoChevronDown />}
            </span>
          </div>
          <div className="hstack gap-3 w-100 flex-wrap">
            {itemsToShow.map((item, index) => (
              <div key={index} className="card border-0">
                <div className="card-img-overlay hstack flex-column justify-content-between w-100">
                  <div className="hstack justify-content-end">
                    <span className="bg-dark text-white rounded-pill pe-2 ps-1 pb-1 hstack fs-13 fw-bold">
                      ⭐ {item.rating}
                    </span>
                  </div>
                  <div className="w-100">
                    <h5 className="m-0">{item.name}</h5>
                    <span className="m-0 mb-2">{item.Year}</span>
                    <div className="hstack justify-content-between">
                      <button className="btn btn-primary fs-13 watch-now">
                        Watch Now
                      </button>
                      <button
                        className="bg-secondary btn fs-13 border-0"
                        title={
                          added ? "remove from watchlist" : "add to watchlist"
                        }
                        onClick={() => setAdded(!added)}
                      >
                        {added ? (
                          <FaCheck className="text-white fs-10" />
                        ) : (
                          <FaPlus className="text-white fs-10" />
                        )}
                      </button>
                    </div>
                  </div>
                </div>
                <img
                  src={item.src}
                  className="card-img"
                  alt={item.name}
                  style={{ height: 325 }}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainContentPage;
